/* eslint-disable */
export default {
  ru: {
    title: 'Во&nbsp;всех тарифах',
    items: {
      'unlimited-vacancies': {
        caption: 'Количество вакансий без&nbsp;ограничений',
        modal: {
          title: 'Количество вакансий&nbsp;&mdash;<br> без ограничений',
          text: 'Неважно, сколько вакансий у&nbsp;вас в&nbsp;работе&nbsp;&mdash; с&nbsp;Хантфлоу вы&nbsp;не&nbsp;беспокоитесь о&nbsp;том, что вдруг упретесь в&nbsp;лимит по&nbsp;вакансиям.',
          button: 'Оставить заявку',
        },
      },
      'unlimited-storage': {
        caption: 'Объем места для&nbsp;файлов без&nbsp;ограничений',
        modal: {
          title: 'Объем места для файлов&nbsp;&mdash;<br> без ограничений',
          text: 'В&nbsp;Хантфлоу нет лимита на&nbsp;объем места для файлов. Вам не&nbsp;нужно решать, какие файлы важны, а&nbsp;от&nbsp;каких придется отказаться, ради экономии места.',
          button: 'Оставить заявку',
        },
      },
      'hiring-managers': {
        caption: 'Добавление нанимающих менеджеров бесплатно',
        modal: {
          title: 'Добавление нанимающих менеджеров бесплатно',
          text: 'Важно, чтобы вcе участники подбора работали в&nbsp;одной системе. Поэтому мы&nbsp;сделали рабочие места для нанимающих менеджеров бесплатными: они прямо в&nbsp;Хантфлоу подают заявки на&nbsp;подбор, оценивают кандидатов и&nbsp;отслеживают статистику по&nbsp;своим вакансиям.',
          button: 'Оставить заявку',
        },
      },
    },
  },
  en: {
    title: 'For all plans',
    items: {
      'unlimited-vacancies': {
        caption: 'Unlimited number of&nbsp;vacancies',
        modal: {
          title: 'Unlimited number of&nbsp;vacancies',
          text: 'No&nbsp;matter on&nbsp;how many vacancies you are working right now. With Huntflow you don&rsquo;t have to&nbsp;worry about running into a&nbsp;vacancy limit.',
          button: 'Request a&nbsp;demo',
        },
      },
      'unlimited-storage': {
        caption: 'Unlimited cloud space for&nbsp;files',
        modal: {
          title: 'Unlimited cloud space for&nbsp;files',
          text: 'There is&nbsp;no&nbsp;limit on&nbsp;the cloud space for files in&nbsp;Huntflow. You don&rsquo;t have to&nbsp;decide which files are important and which ones you&rsquo;ll have to&nbsp;discard in&nbsp;order to&nbsp;save some space.',
          button: 'Request a&nbsp;demo',
        },
      },
      'hiring-managers': {
        caption: 'Add hiring managers for&nbsp;free',
        modal: {
          title: 'Add hiring managers for&nbsp;free',
          text: 'It&nbsp;is&nbsp;important that everyone involved in&nbsp;the hiring process works in&nbsp;one system. That&rsquo;s why we&nbsp;made free workplaces for hiring managers: they submit vacancy requests, evaluate candidates, and track statistics on&nbsp;their job openings right in&nbsp;Huntflow.',
          button: 'Request a&nbsp;demo',
        },
      },
    },
  },
};
